export default "__VITE_ASSET__CEp6s0xc__"